import { render, staticRenderFns } from "./cms-product-item-drawer.vue?vue&type=template&id=bec87efa&scoped=true&"
import script from "./cms-product-item-drawer.vue?vue&type=script&lang=js&"
export * from "./cms-product-item-drawer.vue?vue&type=script&lang=js&"
import style0 from "./cms-product-item-drawer.vue?vue&type=style&index=0&id=bec87efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec87efa",
  null
  
)

export default component.exports